import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
import { CheckCircle, XCircle, Loader2, Utensils } from 'lucide-react';
import axios from 'axios';
import { getBackendUrl } from '../utils/config';

const ActivatePage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const activateAccount = async () => {
      try {
        const api = axios.create({ baseURL: `${getBackendUrl()}/api` });
        await api.get(`/auth/activate/${token}`);
        setStatus('success');
        toast.success('Account geactiveerd!');
      } catch (error) {
        setStatus('error');
        setErrorMessage(error.response?.data?.detail || 'Activatie mislukt');
        toast.error('Activatie mislukt');
      }
    };

    if (token) {
      activateAccount();
    } else {
      setStatus('error');
      setErrorMessage('Geen activatietoken gevonden');
    }
  }, [token]);

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 mb-8 justify-center">
          <div className="w-12 h-12 rounded-xl bg-[#C2410C] flex items-center justify-center">
            <Utensils className="w-6 h-6 text-white" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-[#1C1917]" style={{ fontFamily: 'Manrope' }}>
              Horeca Dashboard
            </h2>
          </div>
        </div>

        {status === 'loading' && (
          <Card className="border-stone-200">
            <CardHeader className="text-center">
              <div className="w-16 h-16 rounded-full bg-stone-100 flex items-center justify-center mx-auto mb-4">
                <Loader2 className="w-8 h-8 text-stone-600 animate-spin" />
              </div>
              <CardTitle style={{ fontFamily: 'Manrope' }}>Account activeren...</CardTitle>
              <CardDescription>
                Even geduld terwijl we je account activeren.
              </CardDescription>
            </CardHeader>
          </Card>
        )}

        {status === 'success' && (
          <Card className="border-emerald-200 bg-emerald-50">
            <CardHeader className="text-center">
              <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-4">
                <CheckCircle className="w-8 h-8 text-emerald-600" />
              </div>
              <CardTitle style={{ fontFamily: 'Manrope' }}>Account Geactiveerd!</CardTitle>
              <CardDescription>
                Je account is succesvol geactiveerd. Je kunt nu inloggen.
              </CardDescription>
            </CardHeader>
            <CardContent>
              <Button 
                onClick={() => navigate('/login')}
                className="w-full btn-primary"
              >
                Naar Inloggen
              </Button>
            </CardContent>
          </Card>
        )}

        {status === 'error' && (
          <Card className="border-rose-200 bg-rose-50">
            <CardHeader className="text-center">
              <div className="w-16 h-16 rounded-full bg-rose-100 flex items-center justify-center mx-auto mb-4">
                <XCircle className="w-8 h-8 text-rose-600" />
              </div>
              <CardTitle style={{ fontFamily: 'Manrope' }}>Activatie Mislukt</CardTitle>
              <CardDescription className="text-rose-700">
                {errorMessage}
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-3">
              <Button 
                onClick={() => navigate('/login')}
                className="w-full"
                variant="outline"
              >
                Naar Inloggen
              </Button>
              <p className="text-sm text-center text-stone-500">
                Je kunt op de login pagina een nieuwe activatielink aanvragen.
              </p>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
};

export default ActivatePage;
